
(function(){

	$.enableFoldoutNav = function() {
		// unfold buttons
        const ufItems = $('.cstm-nav-flyout li.nav-item');
        $.each(ufItems, function(i, item) {
			// next level UL
			if( $(item).children('ul').html() ) {
                const clickItem = $('<em class="fa fa-angle-down cstm-click-icon" aria-hidden="true"></em>');
                $(clickItem).bind('click', function() {
					$(item).children('ul').toggle(300, function() {
						$(clickItem).toggleClass('fa-angle-down fa-angle-right');
					});
				});
				$(item).prepend(clickItem).addClass('has-childs');
			}
		});

        if($('html').hasClass('mobile')) {
            $('#cstm--nav-primary a').click( function(){
                $('[data-toggle="cstm--nav-primary"]').trigger('click');
            });
        }
	};

	$.smoothScroll = function() {
        const url = window.location.href;

        const smScItems = $('a.scroll-smooth, nav a');
        const scrollOffset = 6;

        // if we have an anchor on url
        const arr = url.split('#');
        const urlAndPath = typeof arr[0] != 'undefined' ? arr[0] : '';
        const anchor = typeof arr[1] != 'undefined' ? arr[1] : '';
        const anchorSelector = anchor ? '#'+anchor : '';

        if( urlAndPath && anchorSelector && typeof $(anchorSelector).offset() != 'undefined' ) {
			$('html, body').animate( {scrollTop : ( $(anchorSelector).offset().top - scrollOffset ) }, 300);
		}

		if(smScItems.length) {
			$.each(smScItems, function() {

				if(!$(this).attr('href') || $(this).attr('href')==='#') {
					return; // do continue loop
				}

				let _urlArr = $(this).attr('href').split('#');
                let _urlAndPath = typeof _urlArr[0] != 'undefined' ? _urlArr[0] : '';
                let _anchor = typeof _urlArr[1] != 'undefined' ? _urlArr[1] : '';
                let _anchorSelector = _anchor ? '#'+_urlArr[1] : '';

				if(!_anchor) {
					return; // do continue loop
				}

				// continue and do nothing if anchor item does not exist on this page
				if( (_anchor && typeof $(_anchorSelector).offset() == 'undefined') // we have an url but no anchor target
					|| $(this).attr('data-toggle') // or other function than scrolling
				) {
					return; // do continue loop
				}

				if( $(this).attr('href') && $(this).attr('href').match(/#/) != null ) {
					if( _urlAndPath && _anchor && typeof $(_anchorSelector).offset() != 'undefined') {
						$(this).bind('click', function() {
							$('html, body').animate( {scrollTop : ('top'===_anchor ? 0 : ( $(_anchorSelector).offset().top - scrollOffset ) ) }, 300);
							return false;
						});
					}
				}
			});
		}
	};

    function pageLoaded()  {
        $.enableFoldoutNav();

        $('[data-toggle="cstm--nav-primary"]').click(function () {
            $('#cstm--nav-primary').toggleClass('active');
            $('html').toggleClass('not-scrollable');
            $(this).toggleClass('active');
        });

        $.smoothScroll();
        //console.log('loaded ui-nav');
    }

    // add livewire navigated listener
    document.addEventListener('livewire:navigated', function () {
        pageLoaded();
    });

    // livewire is not installed
    if (typeof Livewire === "undefined") {
        // do jquery basic stuff after page has loaded
        $(function(){
            pageLoaded();
        });
    }

})(jQuery);
